import store from "@/store";
import admin from "@/urls/roles/admin";
import viewer from "@/urls/roles/viewer";
import entitled from "@/urls/roles/entitled";
import representative from "@/urls/roles/representative";
import responsible from "@/urls/roles/responsible";
import guard from "@/urls/roles/guard";

import core_names from "@/modules/core/routers/names"
import admin_names from "@/modules/admin/routers/names";
import viewer_names from "@/modules/viewer/routers/names";
import entitled_names from "@/modules/entitled/routers/names";
import representative_names from "@/modules/representative/routers/names";
import responsible_names from "@/modules/responsible/routers/names";
import guard_names from "@/modules/guard/routers/names";

export function getInstMenu() {
    /**
     * Функция которая возвращает нижнее боковое меню инстанса
     * @return {Array} - списко всех подмодулей инстанса, отображаемых в левом нижнем меню
     */
    let menu = []
    // menu.push({title: 'Главное меню', icon: 'home', router: core_names.MAIN, name: core_names.MAIN})
    if (admin.ADMIN.ALLOWED())
        menu.push({title: "Администратор", icon: "admin_panel_settings", router: admin_names.MAIN, name: admin_names.MAIN})
    if (viewer.VIEWER.ALLOWED())
        menu.push({title: "Наблюдатель", icon: "visibility", router: viewer_names.MAIN, name: viewer_names.MAIN})
    if (entitled.ENTITLED.ALLOWED())
        menu.push({title: "Согласующий", icon: "supervised_user_circle", router: entitled_names.ORDERS.LIST, name: entitled_names.ORDERS.LIST})
    if (representative.REPRESENTATIVE.ALLOWED())
        menu.push({title: "Заявитель", icon: "assignment_ind", router: representative_names.ORDERS.LIST, name: representative_names.ORDERS.LIST})
    // if (responsible.RESPONSIBLE.ALLOWED())
    //     menu.push({title: 'Работник', icon: 'person', router: responsible_names.ORDERS.LIST, name: responsible_names.ORDERS.LIST})
    if (guard.GUARD.ALLOWED())
        menu.push({title: "Охрана", icon: "shield", router: guard_names.ORDERS.LIST, name: guard_names.ORDERS.LIST})
    return menu
}

export function getInstNameByRouterName(router) {
    /**
     * Функция которая возвращает нижнее боковое меню инстанса
     * @return {Array} - списко всех подмодулей инстанса, отображаемых в левом нижнем меню
     */
    return getInstMenu().find(el => {
        return router === el.router
    }).name
}
